import { render, staticRenderFns } from "./VNumberField.vue?vue&type=template&id=cdfaa4da&"
import script from "./VNumberField.vue?vue&type=script&lang=js&"
export * from "./VNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VNumberField.vue"
export default component.exports